// Copyright (c) 2025 ParkEngage Inc. All rights reserved.

// This software is the confidential and proprietary information of
// ParkEngage Inc. ("Confidential Information"). You shall not
// disclose such Confidential Information and shall use it only in
// accordance with the terms of the license agreement you entered into
// with ParkEngage Inc.

// This source code is a valuable trade secret of ParkEngage Inc.

// THIS SOFTWARE IS PROVIDED BY ParkEngage Inc. ``AS IS'' AND ANY
// EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
// IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
// PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL [YOUR COMPANY NAME] OR
// CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
// EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
// PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
// PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
// OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
// (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
// OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.

// The views and conclusions contained in the software and documentation
// are those of the authors and should not be interpreted as representing
// official policies, either expressed or implied, of ParkEngage Inc.

import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { EMPTY_ARRAY, EMPTY_OBJECT, saveCard, keycardStatus } from '../../../constants/globalConstants'
import { getPermitDataList, getPermitQR, CancelPermit, PermitRenewData, AddServicePermitAction, CancelPermitRenew, keycardReplacementRequestAction, keycardReplacementDetails } from '../../../redux/actions/PermitListAction'
import { Circles } from 'react-loader-spinner'
import { renderNoResults } from '../../../components/global/NoDataFound'
// import { staticStrings } from '../../../constants/staticStrings'
import { errorMessage } from '../../../constants/errorMessage'
import moment from 'moment'
import { handlingPermitServiceCriteria, perkingParkingTimeAccount, isPermissionExist, sortPortalPermissionByKey, encryptionHandler, isLoggedIn, validExpiryDate, shouldShowVehicleColumn, isActivePermit, employerDetailsSection, validatorRule, handleValidator, excludeKeysFromValidator, formatYearMonthExpiry, formatDecimal } from '../../../utils/helper'
import AddCardPaymentModal from '../../../components/global/addCardPaymentModal'
import { getCardDataList } from '../../../redux/actions/cardDetailsAction'
import ModalTerm from '../../../pages/responsiveReservation/termCond'
import ConfermationModal from '../../../components/global/ConfermationModal'
import PassWalletButtons from '../../../components/global/PassWalletButtons'
import { APICONFIG } from '../../../redux/config/apiConfig'
import useMobileView from '../../../Hooks/useMobileView'
import ConfirmationModal from '../../../components/global/modal/ConfirmationModal'
import TCAcceptanceSection from '../../../Global/TCAcceptanceSection'
import SimpleReactValidator from 'simple-react-validator'
// import permitTypeLogo from '../../../assets/img/permit_type_account.png'
// import { Link } from 'react-router-dom'

// let moment = require('moment')

function PermitAccount(props) {
    const { dispatch, loader, notify, partnerDetails } = props

    const validator = useRef(new SimpleReactValidator({
        element: message => <span className="form-text text-danger h-40">{message}</span>,
        validators: validatorRule
    }))
    const [, forceUpdate] = useState()

    const [permitListData, setPermitListData] = useState(EMPTY_ARRAY)
    // const [userData, setUserData] = useState(EMPTY_OBJECT)
    const [displayVehicle, setDisplayVehicle] = useState(false)
    const [downloadQR, setDownloadQR] = useState(false)
    const [displayError, setDisplayError] = useState('')
    const [accessPermissions, setAccessPermissions] = useState('')
    const [permit_no, setPermitNo] = useState(EMPTY_OBJECT)
    const [isModalOpen, setModal] = useState(false)
    const [cardExpiryMessage, setCardExpiryMessage] = useState('')

    //new

    const [expiry, setExpiry] = useState()

    const [card, setCard] = useState()

    const [payload, setPayload] = useState(saveCard)

    const [isLoading, setIsLoading] = useState(false)

    const [errorMessagePay, setErrorMessagePay] = useState('')

    const [cardList, setCardList] = useState(EMPTY_ARRAY)

    const [isCardFormVisible, setCardFormVisible] = useState(false)

    const [error, setError] = useState(false)

    const [isConsent, setIsConsent] = useState(true)

    const [showTerm, setTermShow] = useState(false)
    const [displayCheckIn, setDisplayCheckIn] = useState(false)
    const [cancelModal, setCancelModal] = useState(false)
    const [permitdata, setPermitData] = useState(EMPTY_OBJECT)
    const [isCancelLoading, setIsCancelLoading] = useState(false)
    const [buyoutType, setBuyoutType] = useState(false)
    const [showKeyCardChangeModal, setShowKeyCardChangeModal] = useState(false)
    const [keyCardData, setKeyCardData] = useState({
        userAcknowledge: false,
        tc_acceptance_signature: '',
        tc_acceptance_date: new Date(),
        facility_id: ''
    })
    const [formError, setFormError] = useState(false)

    // EOS-973
    const [isFiservGateway, setIsFiservGateway] = useState(false)
    const tokenRef = useRef(null)
    const [cardToken, setCardToken] = useState('')
    const [iframeErrorMsg, setIframeErrorMsg] = useState('')
    const [facilityDetails, setFacilityDetails] = useState([])
    // EOS-973

    // to handle the vehicle for menlo
    const allHaveMst_model = localStorage.getItem('allHaveMst_model') ? JSON.parse(localStorage.getItem('allHaveMst_model')) : true
    const isMobile = useMobileView()
    const keyCardModalRef = useRef(null)


    let dateDisplayFormat = 'DD MMM, YYYY'

    useEffect(() => {
        const getAccessPermissionData = sortPortalPermissionByKey(partnerDetails, 'Restricted Permissions')
        setAccessPermissions(getAccessPermissionData)
    }, [EMPTY_ARRAY, partnerDetails])


    const getPermitList = () => {
        dispatch(getPermitDataList()).then((res) => {
            if (res?.data && res?.data != null) {
                // const userData = localStorage.getItem('userData')
                // const userDetails = JSON.parse(userData)
                // setUserData(userDetails)
                setPermitListData(res?.data)
                setIsConsent(res?.data?.user_consent == '1' ? true : false)
            } else {
                setDisplayError(res?.errors && res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
            }
        }).catch((err) => {
            setDisplayError(err?.errors && err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
        })
    }

    useEffect(() => {
        // setTimeout(
        getPermitList()
        //     if (res) {
        //         // const userData = localStorage.getItem('userData')
        //         // const userDetails = JSON.parse(userData)
        //         // setUserData(userDetails)
        //         setPermitListData(res)
        //     }
        // })
        // , 500)

        if (isLoggedIn()) {
            setCardFormVisible(false)
            // const facility_id = partnerDetails?.facilities?.[0]?.id
            dispatch(getCardDataList()).then((res) => {
                if (res?.data) {
                    setCardList(res?.data?.payments)
                    // setIsLoading(false)
                }
            }).catch(() => {
                // setIsLoading(false)
            })
        } else {
            setCardFormVisible(true)
        }

    }, [EMPTY_ARRAY])

    const handleModalTerm = () => {
        setTermShow(!showTerm)
    }

    const handlePaymentModalOpen = (item) => {
        setPermitNo(item)
        setModal(true)
        setPayload({ ...payload, payable_permit_amount: item?.permit_final_amount })
    }

    useEffect(() => {
        // Check if this is Fiserv payment gateway
        const paymentTypeId = permit_no?.facility?.facility_payment_details?.facility_payment_type_id        
        setIsFiservGateway(paymentTypeId == '3')
        setFacilityDetails(permit_no?.facility)
    },[permit_no])

    const handleCardSelectChange = (e) => {

        const { value } = e.target

        const selectedCard = cardList?.filter((card) => card?.payment_profile_id == value)

        payload['payment_profile_id'] = selectedCard[0]?.payment_profile_id

        setPayload({ ...payload })

    }

    const handleExpiryChange = (value) => {

        let expiryDateCheck = validExpiryDate(value)
        if (value.length == 4 && !expiryDateCheck) {
            setCardExpiryMessage('Enter a valid expire date')
        } else {
            setCardExpiryMessage('')
            setExpiry(value?.trim())
            payload['expiration_date'] = value?.trim()
            setPayload({ ...payload })
        }

    }



    // const handleExpiryChange = (value) => {

    //     setExpiry(value?.trim())

    //     payload['expiration_date'] = value?.trim()

    //     setPayload({ ...payload })

    // }



    const handleCardChange = (value) => {

        setCard(value?.trim())

        payload['card_number'] = value?.trim()

        setPayload({ ...payload })

    }

    const hanndleCancel = () => {
        setPayload({ card_number: '', expiration_date: '', payment_profile_id: '' })
        setCard('')
        setExpiry('')
        setModal(false)
    }

    const handleInputFieldsData = (e) => {
        const { name, value } = e.target
        setPayload({ ...payload, [name]: value })

    }




    const handleSubmit = () => {

        setError(true)

        setIsLoading(true)

        if (Object.values(payload)?.length > 0 && payload?.payment_profile_id || (payload?.name_on_card && payload?.card_number && payload?.card_number?.length === 16 && payload?.expiration_date && payload?.security_code) || (cardToken && cardToken?.token && !iframeErrorMsg)) {

            payload.zip_code = payload?.zip_code_on_card ? payload?.zip_code_on_card : ''

            let finalPayload

            setErrorMessagePay('')

            if (!payload?.payment_profile_id || payload?.payment_profile_id == '') {
                let nonce
                if(isFiservGateway){
                    const tokenizedCard = {
                        card_number: cardToken?.message || cardToken?.token,
                        expiration_date: formatYearMonthExpiry(cardToken?.expiry),
                        security_code: cardToken?.cvv || '',
                    }
                    nonce = encryptionHandler(tokenizedCard)
                }else{
                    nonce = encryptionHandler(payload)
                }
                finalPayload = {

                    'nonce': nonce,

                    'permit_number': permit_no?.account_number,

                    'user_consent': 1,

                    'payable_permit_amount': payload?.payable_permit_amount ? payload?.payable_permit_amount : '',

                }

            } else {

                finalPayload = {

                    'payment_profile_id': payload?.payment_profile_id,

                    'permit_number': permit_no?.account_number,

                    'user_consent': 0,

                    'payable_permit_amount': payload?.payable_permit_amount ? payload?.payable_permit_amount : '',

                }

            }

            dispatch(PermitRenewData(finalPayload)).then((res) => {

                if (res && res?.data !== null) {

                    notify('success', 'Payment is made successfully')

                    setPayload({ card_number: '', expiration_date: '', payment_profile_id: '' })

                    setCard('')

                    setExpiry('')

                    setModal(false)

                    setError(false)

                    setIsLoading(false)

                    dispatch(getPermitDataList()).then((res) => {

                        if (res?.data && res?.data != null) {

                            // const userData = localStorage.getItem('userData')

                            // const userDetails = JSON.parse(userData)

                            // setUserData(userDetails)

                            setPermitListData(res?.data)

                        } else {

                            setDisplayError(res?.errors && res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)

                        }

                    }).catch((err) => {

                        setDisplayError(err?.errors && err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                        setIsLoading(false)
                    })

                } else if (res?.data === null && res?.errors?.message) {

                    notify('error', res?.errors?.message ? res?.errors?.message : 'Something went wrong, Please try again!')

                    setIsLoading(false)

                } else {
                    notify('error', res?.errors?.message ? res?.errors?.message : 'Something went wrong, Please try again!')
                    setIsLoading(false)
                }

            }).catch((err) => {

                // setErrorMessage(err?.errors?.message)

                notify('error', err?.errors?.message ? err?.errors?.message : 'Something went wrong, Please try again!')
                setIsLoading(false)
            })

        } else {
            if(iframeErrorMsg && iframeErrorMsg != ''){
                notify('error', iframeErrorMsg)
            }
            setIsLoading(false)

            setErrorMessagePay('')

        }

    }

    const downloadPermitQr = (id, permitAccount) => {
        setDownloadQR(id)
        if (!downloadQR) {
            dispatch(getPermitQR(id, permitAccount)).then((res) => {
                setDownloadQR(false)
                if (res?.status && res?.status == 500) {
                    notify('error', errorMessage?.somethingWentWrong)
                } else {
                    notify('success', 'File Downloaded')
                }
            }).catch((err) => {
                setDownloadQR(false)
                notify('error', err ? err?.message ? err?.message : errorMessage?.somethingWentWrong : errorMessage?.somethingWentWrong)
            })
        }

    }




    const cancelPermit = () => {
        // setPermitListData
        setIsCancelLoading(true)
        dispatch(CancelPermit(permitdata.id)).then((res) => {
            notify('success', res.msg)
            setCancelModal(false)
            setIsCancelLoading(false)
            setBuyoutType(false)
            getPermitList()
        }).catch((err) => {
            console.log(err)
            setIsCancelLoading(false)
        })

    }

    const cancelPermitRenew = (data, index) => {
        // setPermitListData
        if (data?.is_expired == 0 && data?.cancelled_at == null && data?.stop_renew_consent == '0') {
            let resp = permitListData[index].user_consent == '1' ? '0' : '1'
            permitListData[index].user_consent = resp
            setPermitListData(permitListData)
            setIsConsent(!isConsent)
            dispatch(CancelPermitRenew(data.id)).then((res) => {
                notify('success', res.msg)
                // dispatch(getPermitDataList()).then((res) => {
                //     if (res?.data && res?.data != null) {
                //         // const userData = localStorage.getItem('userData')
                //         // const userDetails = JSON.parse(userData)
                //         // setUserData(userDetails)
                //         setPermitListData(res?.data)
                //     } else {
                //         setDisplayError(res?.errors && res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                //     }
                // }).catch((err) => {
                //     setDisplayError(err?.errors && err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                // })
            }).catch((err) => {
                console.log(err)
            })
        }
    }


    const AddServicePermit = (data, index) => {
        // setPermitListData
        setIsConsent(!isConsent)
        let resp = permitListData[index].permitServiceCarpool == '1' ? '0' : '1'
        permitListData[index].permitServiceCarpool = resp

        //upodate permit service
        //    let permitService= permitListData[index].permitServices
        let carpool = {
            'id': 1,
            // 'partner_id': '363361',
            'permit_service_name': 'Carpool Access',
            // 'permit_service_desc': '',
            // 'open_always': '1',
            // 'permit_service_rate': '0.00',
            // 'is_status': '1',
            // 'created_at': '2024-05-08 15:05:35',
            // 'updated_at': '2024-06-14 00:31:36',
            // 'is_purchase': '1',
            // 'is_negotiable': '0',
            // 'facility_id': null,
            // 'permit_service_criteria_mappings': []
        }
        if (resp == '1') {
            permitListData[index].permitServices.push(carpool)
        } else {
            let carpoolRemove = permitListData[index].permitServices.filter((v) => v.permit_service_name != 'Carpool Access')
            permitListData[index].permitServices = carpoolRemove
        }
        setPermitListData(permitListData)

        const userData = JSON.parse(localStorage.getItem('userData'))
        let payload = {
            permit_service: resp,
            id: data?.id,
            user_id: userData ? userData?.user?.id : '',
        }

        dispatch(AddServicePermitAction(payload)).then((res) => {
            notify('success', res)
            // dispatch(getPermitDataList()).then((res) => {
            //     if (res?.data && res?.data != null) {
            //         setPermitListData(res?.data)
            //     } else {
            //         setDisplayError(res?.errors && res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
            //     }
            // }).catch((err) => {
            //     setDisplayError(err?.errors && err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
            // })
        }).catch((err) => {
            console.log(err)
        })

    }

    const handleshowCheckIn = () => {
        setDisplayCheckIn(!displayCheckIn)
    }


    const showPermitModal = (data) => {
        setPermitData(data)
        setBuyoutType(data?.permit_type_name == 'Buyout' ? true : false)
        setCancelModal(true)
    }


    const handleshowVehicle = () => {
        setDisplayVehicle(!displayVehicle)
    }

    const DisplayField = (label, value) => {
        return <div className="col-6">
            <label className="floatLabel">{label}</label>
            <div className="inputBox">{value || '-'}</div>
        </div>
    }

    const mobileViewVehicleSection = (v = {}, vehicleListIndex, allVehicle) => {
        const vehicle = v?.vehicle
        return <div key={vehicleListIndex} className="row bg-light g-1 p-1 mt-3">
            {DisplayField('License Plate', vehicle?.license_plate_number || '-')}
            {isPermissionExist(accessPermissions, 'Get Vehicle Type') && shouldShowVehicleColumn(allVehicle, 'vehicle_type') ? DisplayField('Vehicle Type', vehicle?.vehicle_type || '-') : null}
            {shouldShowVehicleColumn(allVehicle, 'make') && shouldShowVehicleColumn(allVehicle, 'model') ? DisplayField('Make/Model', (vehicle.make || vehicle.model)
                ? `${vehicle.make ?? ''}${allHaveMst_model && vehicle.model ? ` / ${vehicle.model}` : ''}`
                : '-' || '-') : null}
            {shouldShowVehicleColumn(allVehicle, 'color') ? DisplayField('Color', vehicle?.color || '-') : null}
            {isPermissionExist(accessPermissions, 'Get Vehicle Style') && shouldShowVehicleColumn(allVehicle, 'style') ? DisplayField('Style', vehicle?.style || '-') : null}

            {isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode') && shouldShowVehicleColumn(allVehicle, 'country') ? DisplayField('Country', vehicle?.country || '-') : null}
            {shouldShowVehicleColumn(allVehicle, 'state_code') ? DisplayField('State', vehicle?.state_code || '-') : null}
            {isPermissionExist(accessPermissions, 'Vin Number') && shouldShowVehicleColumn(allVehicle, 'vehicle_number') ? DisplayField('VIN', vehicle?.vehicle_number || '-') : null}
        </div>
    }

    const renderVehicleRow = (v, i, allVehicle) => {
        const vehicle = v?.vehicle || {}
        return (
            <tr key={i}>
                <td className="px-0">{vehicle.license_plate_number || '-'}</td>
                {isPermissionExist(accessPermissions, 'Get Vehicle Type') && shouldShowVehicleColumn(allVehicle, 'vehicle_type') && (
                    <td className="px-0">{vehicle.vehicle_type || '-'}</td>
                )}
                {shouldShowVehicleColumn(allVehicle, 'make') && shouldShowVehicleColumn(allVehicle, 'model') ? <td className="px-0">
                    {(vehicle.make || vehicle.model)
                        ? `${vehicle.make ?? ''}${allHaveMst_model && vehicle.model ? ` / ${vehicle.model}` : ''}`
                        : '-'}
                </td> : null}
                {shouldShowVehicleColumn(allVehicle, 'color') ? <td className="px-0">{vehicle.color || '-'}</td> : null}
                {isPermissionExist(accessPermissions, 'Get Vehicle Style') && shouldShowVehicleColumn(allVehicle, 'style') && (
                    <td className="px-0">{vehicle.style || '-'}</td>
                )}
                {isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode') && shouldShowVehicleColumn(allVehicle, 'country') && (
                    <td className="px-0">{vehicle.country || '-'}</td>
                )}
                {shouldShowVehicleColumn(allVehicle, 'state_code') ? <td className="px-0">{vehicle.state_code || '-'}</td> : null}
                {isPermissionExist(accessPermissions, 'Vin Number') && shouldShowVehicleColumn(allVehicle, 'vehicle_number') && (
                    <td className="px-0">{vehicle.vehicle_number || '-'}</td>
                )}
            </tr>
        )
    }

    const deskTopViewVehicleSection = (item = {}) => {
        return <div className='table-responsive'>
            <table className="table table-borderless table-sm mb-0">
                <thead>
                    <tr>
                        <th className="fw-bold px-0">License Plate</th>
                        {shouldShowVehicleColumn(item?.permit_vehicle, 'make') && shouldShowVehicleColumn(item?.permit_vehicle, 'model') ? <th className="fw-bold px-0">{`Make${allHaveMst_model ? ' / Model' : ''}`}</th> : null}
                        {isPermissionExist(accessPermissions, 'Get Vehicle Type') && shouldShowVehicleColumn(item?.permit_vehicle, 'vehicle_type') && (
                            <th className="fw-bold px-0">Vehicle Type</th>
                        )}
                        {shouldShowVehicleColumn(item?.permit_vehicle, 'color') ? <th className="fw-bold px-0">Color</th> : null}
                        {isPermissionExist(accessPermissions, 'Get Vehicle Style') && shouldShowVehicleColumn(item?.permit_vehicle, 'style') && (
                            <th className="fw-bold px-0">Style</th>
                        )}
                        {isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode') && shouldShowVehicleColumn(item?.permit_vehicle, 'country') && (
                            <th className="fw-bold px-0">Country</th>
                        )}
                        {shouldShowVehicleColumn(item?.permit_vehicle, 'state_code') ? <th className="fw-bold px-0">State</th> : null}
                        {isPermissionExist(accessPermissions, 'Vin Number') && shouldShowVehicleColumn(item?.permit_vehicle, 'vehicle_number') && (
                            <th className="fw-bold px-0">VIN</th>
                        )}
                    </tr>
                </thead>

                <tbody>
                    {renderVehicleRow(item?.permit_vehicle?.[0], 0, item?.permit_vehicle)}
                </tbody>

                <tbody className="collapse" style={{ height: '300px' }} id={`vehicleCollapse-${item?.id}`}>
                    {(item?.permit_vehicle?.slice(1) || []).map((v, i) => renderVehicleRow(v, i + 1, item?.permit_vehicle))}
                </tbody>
            </table>
        </div>
    }

    const formValidation = (validFields = []) => {
        if (!handleValidator(validator, validFields, forceUpdate)) {
            return false
        }

        const termsPermission =
            !isPermissionExist(accessPermissions, 'Display Terms & Conditions') ||
            (
                isPermissionExist(accessPermissions, 'Display Terms & Conditions') &&
                keyCardData?.userAcknowledge
            )

        const tcAcceptanceCondition =
            !isPermissionExist(accessPermissions, 'Display TC Acceptance') ||
            (
                isPermissionExist(accessPermissions, 'Display TC Acceptance') &&
                keyCardData?.tc_acceptance_signature
            )

        if (!termsPermission) {
            setFormError('permitAccount')
        }

        const finalCondition = (termsPermission && tcAcceptanceCondition)

        return finalCondition
    }

    const handleKeyCardChangeRequest = (item = {}) => {

        const tc_acceptance_date = keyCardData?.tc_acceptance_date ? moment(keyCardData?.tc_acceptance_date).format('YYYY/MM/DD') : moment().format('YYYY/MM/DD')

        let formPostData = new FormData()    //formdata object
        formPostData.append('user_id', item?.user?.id)
        formPostData.append('permit_id', item?.id)
        formPostData.append('partner_id', item?.partner_id)
        formPostData.append('tc_acceptance_signature', keyCardData?.tc_acceptance_signature)
        formPostData.append('tc_acceptance_date', tc_acceptance_date)

        let filteredValidatorFieldKeys = excludeKeysFromValidator(validator, false, keyCardData, accessPermissions)
        let allValid = formValidation(filteredValidatorFieldKeys)

        // If valid, continue as before.
        return allValid ? dispatch(keycardReplacementRequestAction(formPostData)).then(() => {
            notify('success', 'Replacement request submitted successfully.')
            getPermitList()
            setShowKeyCardChangeModal(false)
        }).catch((err) => {
            console.log(err)
        }) : false
    }

    const keyCardDescription = () => {
        return <>
            <p>
                Please confirm that you would like to request a change to your assigned keycard.
            </p>
            <p className='text-muted small'>
                <i>
                    Note: Once the new card is activated, your existing keycard will no longer be valid. Please ensure that you wish to proceed.
                </i>
            </p>
            {(() => {
                // Use replacementDetails from keyCardModalRef if available
                const replacementDetails = keyCardModalRef?.current?.replacementDetails
                if (!replacementDetails) return null
                const {
                    replacement_price,
                    processing_fee,
                    tax_fee,
                    total_amount
                } = replacementDetails

                return (
                    <div>
                        <strong>Charges Breakdown:</strong>
                        <table className="table table-borderless table-sm mb-0 mt-2">
                            <tbody>
                                <tr>
                                    <td>Replacement Price</td>
                                    <td>
                                        {replacement_price !== undefined && replacement_price !== null
                                            ? `$${formatDecimal(replacement_price)}`
                                            : '-'}
                                    </td>
                                </tr>
                                {Number(processing_fee) > 0 && (
                                    <tr>
                                        <td>Processing Fee</td>
                                        <td>
                                            {processing_fee !== undefined && processing_fee !== null
                                                ? `$${formatDecimal(processing_fee)}`
                                                : '-'}
                                        </td>
                                    </tr>
                                )}
                                {Number(tax_fee) > 0 && (
                                    <tr>
                                        <td>Tax</td>
                                        <td>
                                            {tax_fee !== undefined && tax_fee !== null
                                                ? `$${formatDecimal(tax_fee)}`
                                                : '-'}
                                        </td>
                                    </tr>
                                )}
                                <tr>
                                    <td><strong>Total Amount</strong></td>
                                    <td>
                                        <strong>
                                            {total_amount !== undefined && total_amount !== null
                                                ? `$${formatDecimal(total_amount)}`
                                                : '-'}
                                        </strong>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                )
            })()}
            <TCAcceptanceSection
                accessPermissions={accessPermissions}
                formData={keyCardData}
                setFormData={setKeyCardData}
                formError={formError == 'permitAccount'}
                partnerDetails={partnerDetails}
                validator={validator}
                showTerm={showTerm}
                setShowTerm={setTermShow}
                handleInputFieldsData={(e) => {
                    const { name, value } = e.target
                    setKeyCardData({ ...keyCardData, [name]: value })
                }}
            />
        </>
    }

    const handleResetData = () => {
        setKeyCardData({
            userAcknowledge: false,
            tc_acceptance_signature: '',
            tc_acceptance_date: new Date(),
            facility_id: ''
        })
        setFormError(false)
    }


    return (
        loader ? <span className='ms-2 d-flex justify-content-center'><Circles
            height="50"
            width="50"
            color="var(--bs-primary)"
            ariaLabel="circles-loading"
            visible={true}
        /></span> :
            <div>
                <div className="d-flex justify-content-between mb-4">
                    <h4 className="fw-bold">Permit Account </h4>
                    {isPermissionExist(accessPermissions, 'Display Terms & Conditions') ? <p><i className='fa fa-link me-2'></i><a href='javascript:;' onClick={handleModalTerm} className=''><b>Terms & Conditions</b></a></p> : null}

                    {/* <Link to='/'>
                    <button className="btn btn-success ms-auto"><i className="fa fa-plus"></i> Add</button>
                </Link> */}
                </div>
                {permitListData?.length > 0 ?
                    <ul className="permitList">
                        {permitListData?.map((item, index) => {
                            if (item == null) return null

                            let permitUsagelist = []
                            let permitUsageRemaning = item?.remaining_usage ? Number(item?.remaining_usage) : null

                            // let permitUsage=item?.ticket_count ? Number(item?.ticket_count) :null

                            let totalUsage = item?.total_usage ? Number(item?.total_usage) : null

                            if (totalUsage && totalUsage > 0) {
                                for (let i = 1; i <= totalUsage; i++) {
                                    permitUsagelist.push(<li key={i} className={permitUsageRemaning >= i ? 'active' : 'inactive'}></li>)
                                }
                            }

                            return (
                                <li className={`TicketCardStyle mb-5 ${isActivePermit(item) ? 'active border-success' : item?.cancelled_at != null ? 'inactive border-danger' : 'inactive border-secondary'}`} key={index}>
                                    {/* title box started here */}
                                    <div className='d-flex justify-content-sm-between mb-4 gap-2 align-items-sm-center flex-column flex-sm-row'>
                                        <div id='titles' className='d-flex gap-2'>
                                            <i className={`fa fa-parking fa-2x   ${isActivePermit(item) ? 'text-success ' : item?.cancelled_at != null ? 'text-danger' : 'text-secondary'}`}></i>
                                            <div  >
                                                <h4 style={{ lineHeight: '0.7' }} className={`mb-0 fw-bold d-block  lh-0  ${isActivePermit(item) ? 'text-success ' : item?.cancelled_at != null ? 'text-danger' : 'text-secondary'} `}> Permit No #{item?.account_number} </h4>
                                                {/* <small>{item?.permit_rate?.name} Plan</small> */}
                                                {isActivePermit(item) ? <button
                                                    className='btn d-flex gap-1 align-items-center p-0 text-primary'
                                                    type='button'
                                                    disabled={downloadQR}
                                                    onClick={() => downloadPermitQr(item?.id, item?.account_number)}>
                                                    {/* <i className='fa fa-qrcode'></i>  */}

                                                    <b>Download QR</b>
                                                    <i className='fa fa-download'></i>
                                                    {downloadQR == item?.id ? <span className=' ms-1'><Circles
                                                        height="20"
                                                        width="20"
                                                        color="#000"
                                                        ariaLabel="circles-loading"
                                                        visible={true}
                                                    /></span> : null}
                                                </button>
                                                    : ''}
                                            </div>

                                            {/* <small className={item?.is_expired == 0 && item?.cancelled_at == null ? 'text-success' : 'text-white'}><i className='fa fa-circle '></i> {item?.is_expired == 0 && item?.cancelled_at == null ? 'Active' : item?.cancelled_at == null ? 'In-active' : 'Canceled'}</small> */}
                                        </div>
                                        <div className='d-block text-end'>
                                            <div className=''>Status - <span className={` fw-bold ${isActivePermit(item) ? 'text-success' : item?.cancelled_at != null ? 'text-danger' : 'text-secondary'}`}> {isActivePermit(item) ? 'Active' : item?.cancelled_at != null ? 'Cancelled' : (item.is_expired == 1) ? 'Expired' : 'In-Active'} </span></div>
                                            <div className=''>{(item?.cancelled_at != null) ? <span>Cancelled at - {item?.cancelled_at ? moment(item?.cancelled_at, 'YYYY-MM-DD hh:mm:ss').format('MM/DD/YYYY') : null} </span> : null}</div>
                                            <div className=''> {(item?.cancelled_at != null && !moment(new Date()).isAfter(moment(item?.grace_end_date), 'day') && !moment(item?.cancelled_at).isAfter(moment(item?.grace_end_date), 'day')) ? 'The Permit is Active and will be cancelled from the next Term.' : null}</div>
                                            <div id='actionButtons' className='d-flex gap-2'>
                                                {((item?.is_expired == 0 && item?.cancelled_at == null) || (item?.user_consent === '1')) && <div className='d-flex gap-3'>

                                                    {/* {item?.user_consent === '1' && <span className='border border-e'></span>} */}



                                                    <div className='form-check  form-switch'>
                                                        <input disabled={item?.is_expired == 0 && item?.cancelled_at == null && item?.stop_renew_consent == '0' ? false : true} type="checkbox" id={`${'cancelAutoRenewToggle' + item.id}`} onClick={() => item?.is_expired == 0 && item?.cancelled_at == null && item?.stop_renew_consent == '0' ? cancelPermitRenew(item, index) : null} checked={item?.user_consent == '1' ? true : false} className='form-check-input' />
                                                        <label htmlFor='cancelAutoRenewToggle' className='form-check-label fw-normal text-danger'>{item?.user_consent == '1' ? 'Disable' : 'Enable'} Auto Renew </label></div>{isPermissionExist(accessPermissions, 'Cancel Permit') && '|'}

                                                    {isPermissionExist(accessPermissions, 'Cancel Permit') ? <button type='button' onClick={() => showPermitModal(item)} className={`btn p-0 text-danger border-0 ${(item?.permit_renew_pay == '1' || item?.cancelled_at == null) ? '' : ' disabled'}`}><i type="checkbox" id='cancelAutoRenewToggle' className='fa fa-times' /> Cancel Permit</button> : ''}


                                                </div>}

                                            </div>


                                        </div>
                                    </div>
                                    {/*  title box ends */}

                                    {/*  devider line */}

                                    <div className='border border-dashed my-4 d-block w-100'></div>

                                    {/*  divider line ends */}
                                    <div className='row justify-content-between align-items-center g-3 mb-3 '>
                                        <div className=' col-lg-4 lh-08 '>
                                            <div className="d-flex align-items-lg-center gap-2">
                                                <i className='fa  fa-ticket'></i>
                                                {/* <img height="32px" src={permitTypeLogo}></img> */}

                                                <div>
                                                    <h4 className='mb-0 fw-bold '>{(isPermissionExist(accessPermissions, 'Hide Facility') && !(item?.permitServices?.some(service => service?.display_facility == 1))) ? null : item?.facility?.full_name ? `${item?.facility?.full_name} -` : ''} </h4>
                                                    <small className='text-muted '>{item?.permit_type_name} {item?.permit_rate?.rate_description?.is_hide_validity == '0' && item?.permit_rate?.rate_description?.description ? `(${item?.permit_rate?.rate_description?.description})` : ''}</small>
                                                </div>
                                            </div>

                                        </div>
                                        <div className=' col-lg-4'>
                                            <div className='dateRangeSelector'>
                                                <div className='d-flex w-full'>
                                                    <div className='leftBlock w-full justify-content-start gap-2 p-2 d-flex align-items-center'>
                                                        <i className='fa fa-calendar text-success '></i>
                                                        <div  >
                                                            <small>Start at</small>
                                                            <h5 className='fw-bold m-0' >{moment(item?.desired_start_date).format('MM/DD/YYYY')}</h5>
                                                        </div>

                                                    </div>
                                                    <div className='rightBlock w-full border-start p-2 justify-content-end text-end gap-2 d-flex align-items-center'>

                                                        <div >
                                                            <small>End at</small>
                                                            <h5 className='fw-bold m-0' >{moment(item?.desired_end_date).format('MM/DD/YYYY')}</h5>
                                                        </div>
                                                        <i className='fa fa-calendar text-danger '></i>

                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                        <div className=' col-lg-4 text-sm-end lh-08'>
                                            {(item?.permit_rate?.rate_description?.is_hide_validity == '0' && item?.permit_rate?.permit_rate_criteria_mapping?.length > 0) ? perkingParkingTimeAccount(item?.permit_rate, true) : null}

                                        </div>
                                    </div>

                                    {/* {item?.hid_card_number && <div className='col-sm-4 col-12 mb-sm-0 mb-3'>
                                        <p><b className='text-muted small'>Prox Card Id: </b><span className='text-black small'>{item?.hid_card_number}</span></p>
                                    </div>} */}
                                    {!(item?.keycard_mappings && (item?.keycard_mappings.length > 0)) && item?.hid_card_number && item?.facility?.facility_configuration?.hid_card_enabled == '1' && (
                                        <div className='col-sm-4 col-12 mb-sm-0 mb-3'>
                                            <p><b className='text-muted small'>Prox Card Id: </b><span className='text-black small'>{item?.hid_card_number}</span></p>
                                        </div>
                                    )}
                                    
                                    {item?.user_type_id && <div className='col-sm-4 col-12 mb-sm-0 mb-3'>
                                        <p><b className='text-muted small'>Student/Staff/Faculty ID: </b><span className='text-black small'>{item?.user_type_id}</span></p>
                                    </div>}

                                    {/* Employer Details Section */}
                                    {employerDetailsSection(item?.employer_details, true)}

                                    {/* uploaded documents */}
                                    {item?.permit_doc?.length > 0 ? <div className='bg-light horizontal-gradient my-3 p-3 rounded-4'>
                                        <div className='d-flex align-items-sm-center gap-sm-5 gap-2 flex-column  flex-sm-row'>
                                            <h5 className='fw-bold m-0 ' > <i className='fa fa-file me-2'></i>  Uploaded Document - </h5>
                                            {item?.permit_doc?.length > 0 ?
                                                item?.permit_doc?.map((item, index) => {
                                                    return (
                                                        <a key={index} href={`${item[item?.document_key]}`} target='_blank' rel="noreferrer" className='text-primary text-start btn p-0 '> <span className="text-dark">{item?.doc_name}</span> <i className='fa fa-eye'></i></a>
                                                    )
                                                })
                                                : <div className='col'>
                                                    <span className='fontsize85'>
                                                        N/A
                                                    </span>
                                                </div>}
                                        </div>
                                    </div> : null}
                                    {/*  second row */}



                                    {/*  second row */}
                                    {/* uploaded documents */}
                                    {/* <div className='bg-light horizontal-gradient my-3 p-3 rounded-4'>
                                    <div className='d-flex align-items-sm-center gap-sm-5 gap-2 flex-column  flex-sm-row'>
                                        <h5 className='fw-bold m-0 ' > <i className='fa fa-file me-2'></i>  Uploaded Document - </h5>

                                        {item?.permit_doc?.length > 0 ?
                                            item?.permit_doc?.map((item, index) => {
                                                return (

                                                    <a key={index} href={`${item[item?.document_key]}`} target='_blank' rel="noreferrer" className='text-primary text-start btn p-0 '> <span className="text-dark">{item?.doc_name}</span> <i className='fa fa-eye'></i></a>

                                                )
                                            })
                                            : <div className='col'>
                                                <span className='fontsize85'>
                                                    N/A
                                                </span>
                                            </div>}
                                    </div>
                                </div> */}
                                    {/* permit service */}
                                    {item?.permitServices?.length > 0 || (isPermissionExist(accessPermissions, 'Permit Category') && item?.permit_rate?.is_hide_carpool_toogle == '0') ? <div className='d-flex flex-sm-row border-top py-2 flex-column justify-content-between'>


                                        <div className='left'>
                                            <b>Permit Services(s)</b>

                                            {item?.permitServices?.length > 0 && item?.permitServices?.map((v, i) => {
                                                if (v?.permit_service_name != 'Select All Access') {
                                                    return (

                                                        <div key={i} className='d-flex  px-0   w-full align-items-center justify-content-between'>
                                                            <div className=' text-muted text-capitalize' >
                                                                {v?.permit_service_name} {(v?.permit_service_criteria_mappings && v?.permit_service_criteria_mappings?.length > 0) ? handlingPermitServiceCriteria(v?.permit_service_criteria_mappings) : null}
                                                            </div>
                                                            {/* <div className='fw-semibold '>
                                                                ${v?.permit_service_rate}
                                                            </div> */}
                                                        </div>
                                                    )
                                                }

                                            })}
                                        </div>

                                        {/* carpool service         */}
                                        {isPermissionExist(accessPermissions, 'Permit Category') && item?.permit_rate?.is_hide_carpool_toogle == '0' ? <div className='form-check  form-switch'>

                                            <input disabled={item?.is_expired == 0 && item?.cancelled_at == null ? false : true} type="checkbox" id='addServiceToggle' checked={item?.permitServiceCarpool == '1' ? true : false} onClick={() => AddServicePermit(item, index)} className='form-check-input' />
                                            <label htmlFor='addServiceToggle' className='form-check-label small fw-normal text-danger'>Carpool Access-$0.00  </label>
                                            <span className="popoverSectionNew position-relative ms-1"  >
                                                <div className='small popoverContent position-absolute shadow-sm bg-white p-2 border'>Please use this toggle to enable/disable Carpool access</div>
                                                <i
                                                    className="fa fa-question-circle "
                                                >
                                                </i>
                                            </span>
                                        </div> : ''}

                                    </div> : ''}

                                    {/* vehicle table section */}

                                    {item?.permit_vehicle && item?.permit_vehicle?.length > 0 &&
                                        <div className='my-3'>
                                            <div className='border border-dashed my-4 d-block w-100'></div>
                                            <div className="d-flex align-items-center mb-2 justify-content-between">
                                                <b>Vehicle(s)</b>
                                                {item?.permit_vehicle?.length > 1 && (
                                                    <div className='d-flex gap-2'>
                                                        <span className='fw-bold text-primary'>
                                                            {`${item?.permit_vehicle?.length} ${item?.permit_vehicle?.length > 1 ? 'Vehicles' : 'Vehicle'}`}
                                                        </span>
                                                        <button
                                                            className='btn btn-outline-dark btn-sm'
                                                            type="button"
                                                            data-bs-toggle="collapse"
                                                            data-bs-target={`#vehicleCollapse-${item?.id}`}
                                                            aria-expanded={displayVehicle}
                                                            aria-controls={`vehicleCollapse-${item?.id}`}
                                                            onClick={handleshowVehicle}
                                                        >
                                                            {displayVehicle ? 'Hide All' : 'View All'}
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                            {isMobile ? <div>
                                                <div>
                                                    {mobileViewVehicleSection(item?.permit_vehicle?.[0], 0, item?.permit_vehicle)}
                                                </div>

                                                <div className="collapse" style={{ height: '300px' }} id={`vehicleCollapse-${item?.id}`}>
                                                    {(item?.permit_vehicle?.slice(1) || []).map((v, i) => mobileViewVehicleSection(v, i + 1, item?.permit_vehicle))}
                                                </div>
                                            </div> : deskTopViewVehicleSection(item)}
                                        </div>
                                    }

                                    {/* driver */}
                                    {item?.authorized_driver && item?.authorized_driver.length > 0 && <div className='col-12 col-sm-12 order-sm-1 order-4 mt-sm-0'>
                                        <div className='border border-dashed my-4 d-block w-100'></div>
                                        <table className='table mt-3' cellSpacing="0px" cellPadding="0">
                                            <tr>
                                                <th className='text-muted border ps-2'>Driver Name:</th>
                                                <th className='text-muted border ps-2'>Document:</th>

                                            </tr>
                                            {item?.authorized_driver?.map((v, i) => {
                                                return (<>
                                                    <tr key={i}>
                                                        <td className='small border ps-2'>{v?.driver_name}</td>

                                                        <td className='small border ps-2'>{v?.url ? <a href={v?.url} target='_blank' rel="noreferrer">View </a> : '-'}</td>


                                                    </tr></>)
                                            })}

                                        </table>
                                        {/* {item?.permit_vehicle?.length > 1 ? <span className=' fw-bold text-primary text-decoration-underline' onClick={() => handleshowVehicle()}>{displayVehicle ? 'Hide All' : 'View All'}</span> : null} */}

                                    </div>
                                    }



                                    <div className='row d-none'>

                                        <div className='col-sm mb-sm-0 mb-3'>

                                            <table cellSpacing="0px" cellPadding="0">
                                                <tr>
                                                    <th className='text-muted d-none'>Driver License No.:</th><td className='px-2'></td> <td className='text-end'>{item?.license_number}</td>
                                                </tr>
                                                {item?.user?.resident_status ? <tr>
                                                    <th colSpan="3" className='text-muted d-none'><span className="badge bg-success"> {item?.user?.resident_status}</span></th>
                                                </tr> : <span className='text-muted d-none'>NA</span>}
                                            </table>
                                            {/* <p className='text-muted mb-0  '>{item?.user?.license_number}<br/>  <b>Driving License No.</b></p> */}
                                        </div>
                                        {item?.permit_vehicle && <div className='col-12 col-sm-12 order-sm-1 order-4 mt-sm-0'>
                                            <table className='table border  mt-3' >
                                                <thead className='border-bottom bg-light' >
                                                    {item?.permit_vehicle[0]?.vehicle?.license_plate_number && <th className='p-2 border-e' >License Plate:</th>
                                                    }
                                                    {item?.permit_vehicle[0]?.vehicle?.color && <th className='p-2 border-e' >Color:</th>
                                                    }
                                                    {item?.permit_vehicle[0]?.vehicle?.make && <th className='p-2 border-e' >Make:</th>
                                                    }
                                                    {item?.permit_vehicle[0]?.vehicle?.model && <th className='p-2 ' >Model:</th>
                                                    }
                                                    {isPermissionExist(accessPermissions, 'Get Vehicle Type') ? <td className='p-0 lh-4' >Vehicle Type</td> : ''}
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        {item?.permit_vehicle[0]?.vehicle?.license_plate_number && <td className='p-2 border-e' >{item?.permit_vehicle[0]?.vehicle?.license_plate_number}</td>
                                                        }
                                                        {item?.permit_vehicle[0]?.vehicle?.color && <td className='p-2 border-e' >{item?.permit_vehicle[0]?.vehicle?.color}</td>
                                                        }
                                                        {item?.permit_vehicle[0]?.vehicle?.make && <td className='p-2 border-e' >{item?.permit_vehicle[0]?.vehicle?.make}</td>
                                                        }
                                                        {item?.permit_vehicle[0]?.vehicle?.model && <td className='p-2 ' >{item?.permit_vehicle[0]?.vehicle?.model}</td>
                                                        }
                                                        {isPermissionExist(accessPermissions, 'Get Vehicle Type') ? <td className='p-0 lh-4' >{item?.vehicle?.vehicle_type ? item?.vehicle?.vehicle_type : '-'}</td> : ''}
                                                    </tr>
                                                </tbody>
                                            </table>
                                            {item?.permit_vehicle?.length > 1 ? <span className='fw-bold text-primary text-decoration-underline cursor' onClick={() => handleshowVehicle()}>{displayVehicle ? 'Hide All' : 'View All'}</span> : null}

                                        </div>
                                        }

                                    </div>

                                    {/* 
                                    {displayVehicle && <span><hr />
                                        <b className='text-muted fw-bold'>Vehicles:</b>
                                        <div className='row align-items-center justify-content-between  '>
                                            <div className='col-sm-12 '>
                                                {item?.permit_vehicle && <div className='col-12 col-sm-auto order-sm-1 order-4 mt-sm-0  '>
                                                    <table cellSpacing="0px" cellPadding="0" className='table'>
                                                        <thead>
                                                            <tr>
                                                                <th className='text-muted'>License Plate</th>
                                                                <th className='text-muted'>Color</th>
                                                                <th className='text-muted'>Make</th>
                                                                <th className='text-muted'>Model</th>
                                                            </tr>
                                                        </thead>
                                                        {item?.permit_vehicle?.length > 0 && item?.permit_vehicle?.map((item, index) => {
                                                            return <tr key={index}>
                                                                <td className='text-start ps-2'>{item?.vehicle?.license_plate_number ? item?.vehicle?.license_plate_number : '-'}</td>
                                                                <td className='text-start ps-2'>{item?.vehicle?.color ? item?.vehicle?.color : '-'}</td>
                                                                <td className='text-start ps-2'>{item?.vehicle?.make ? item?.vehicle?.make : '-'}</td>
                                                                <td className='text-start ps-2'>{item?.vehicle?.model ? item?.vehicle?.model : '-'}</td>
                                                            </tr>
                                                        })}
                                                    </table>

                                                </div>
                                                }
                                            </div>
                                        </div></span>} */}


                                    {/*  transtion card detils */}
                                    <div className='border border-dashed my-4 d-block w-100'></div>

                                    {item?.business_id && item?.business_id != '' ? null : <div className='row g-1 row-cols-1 row-cols-sm-4' >
                                        <div className='col'>
                                            <small className='fw-bold text-muted d-block'> Amount paid  </small>
                                            <p className='m-0'> ${item?.permit_final_amount}</p>
                                        </div>
                                        <div className='col'>
                                            <small className='fw-bold text-muted d-block'> Transaction Number  </small>
                                            <p className='m-0'>{item?.transaction?.anet_trans_id ? item?.transaction?.anet_trans_id : '-'}</p>
                                        </div>
                                        <div className='col'>
                                            <small className='fw-bold text-muted d-block'> Card details </small>
                                            {Number(item?.permit_final_amount) > 0 ? <><p className='m-0'>Ending With - {item?.paymentDetails?.card_last_four ? item?.paymentDetails?.card_last_four : item?.transaction?.payment_last_four ? item?.transaction?.payment_last_four : '-'} </p>
                                                {(item?.transaction?.method != 'APL' && item?.transaction?.method != 'GPAY') ? <p> Exp - {item?.paymentDetails?.expiry ? item?.paymentDetails?.expiry?.slice(0, 2) + '/' + item?.paymentDetails?.expiry?.slice(2, 4) : item?.transaction?.expiration ? item?.transaction?.expiration?.slice(0, 2) + '/' + item?.transaction?.expiration?.slice(2, 4) : '-'}</p> : item?.transaction?.method == 'APL' ? <span className='badge bg-dark small rounded-5 fw-light'><span className='d-flex align-items-center gap-1'>Paid by: <i className='fa-brands fa-apple-pay fs-5'></i></span></span> : item?.transaction?.method == 'GPAY' ? <span className='badge bg-dark small rounded-5 fw-light'><span className='d-flex align-items-center gap-1'>Paid by: <i className='fa-brands fa-google-pay fs-5'></i></span></span> : ''}
                                            </> : '-'} </div>
                                        <div className='col'>
                                            <small className='fw-bold text-muted d-block'> Payment Date  </small>
                                            {Number(item?.permit_final_amount) > 0 ? <p className='m-0'><i className='fa fa-clock'></i> {moment(item?.transaction?.created_at).format('MM/DD/YYYY hh:mm a')}</p> : '-'}
                                        </div>

                                    </div>}
                                    {(item?.reserved_space_number && item?.reserved_space_number != '') ? <div className='row g-1 row-cols-1 row-cols-sm-4' >
                                        <div className='col'>
                                            <small className='fw-bold text-muted d-block'> Preferred Reserved Space Number:  </small>
                                            <p className='m-0'>{item?.reserved_space_number}</p>
                                        </div>
                                    </div> : null}
                                    <div className='row justify-content-end'>
                                        <div className='mt-3 col-sm-4'>
                                            <PassWalletButtons
                                                ticketId={item?.account_number}
                                                googleWalletApi={APICONFIG.getGooglePermitPassDownload}
                                                appleWalletApi={APICONFIG.getapplePermitPassDownload}
                                                notify={notify}
                                                partnerDetails={partnerDetails}
                                            />
                                        </div>
                                    </div>
                                    {/*  card details ends */}




                                    {(isPermissionExist(accessPermissions, 'Display Permit Pay Now') && item?.permit_renew_pay == '1' && Number(item?.total_permit_amount) > 0 && item?.cancelled_at == null) ?
                                        <><div className='border border-dashed my-4 d-block w-100'></div>
                                            <div className='row g-sm-5 g-2   align-items-end justicy-content-between'>


                                                <div className='col-auto flex-grow-1 '>
                                                    <span className='text-muted small d-block lh-0 '>Bill Cycle</span>
                                                    <b >{item?.billing_start_date ? moment(item?.billing_start_date).format(dateDisplayFormat) : ''} - {item?.billing_end_date ? moment(item?.billing_end_date).format(dateDisplayFormat) : ''}</b>
                                                </div>

                                                <div className='col-auto pr-md-4 border-sm-end   '>

                                                    <b className='fw-bold small  lh-0 '>Amount Due</b>
                                                    <h2 className='m-0 lh-5 fw-bold' >
                                                        ${item?.total_permit_amount}
                                                    </h2>





                                                </div>



                                                <div className='col-auto'><button className="btn btn-success" onClick={() => handlePaymentModalOpen(item)}>Pay Now</button>  </div>

                                            </div></> : ''}



                                    <div className='card-footer p-3 d-none'>
                                        <div className='row align-items-center justify-content-between  '>
                                            <div className='col-sm-4 text-end order-sm-1 order-4 '>
                                                {item?.transaction?.total && <p className='mb-0'><b className=' fw-bold'>Paid: </b> ${item?.transaction?.total}</p>}
                                            </div>
                                            {/* production script */}
                                            {/* {item?.permit_renew_pay == '1' && item?.renewal_due_amount > 0  ?  <div className='col-sm-4 '>
                                        <small><b className='fw-bold'>Amount Due:</b>  <br className='d-block d-sm-none' />{item?.renewal_due_amount}</small>
                                        </div>:''} */}
                                            {/*  local script */}
                                            <div className='col-sm-4 '>
                                                <small><b className='fw-bold'>Amount Due:</b>  <br className='d-block d-sm-none' />${item?.transaction?.total}</small>
                                            </div>

                                            {/* <div className='col-sm-4 '> */}
                                            {/* <small><b className='text-muted fw-bold'>Valid Till:</b>  <br className='d-block d-sm-none' />{item?.formatted_desired_end_date}</small> */}
                                            {/* <small><b className='text-muted fw-bold'>Disclaimer:</b>  <br className='d-block d-sm-none' />{staticStrings?.rates24}</small> */}
                                            {/* </div> */}
                                            <div className='col-sm-4 '>
                                                <small><b className='t fw-bold'>Autopay Enabled</b> - <br className='d-block d-sm-none' />{item?.user_consent ? item?.user_consent == '1' ? 'Yes' : 'No' : 'Yes'}</small>
                                            </div>
                                        </div>

                                        {isPermissionExist(accessPermissions, 'Download Permit QR') ? ((item?.is_expired == 0 && item?.cancelled_at == null) || (item?.user_consent === '1')) && <div className='d-flex justify-content-between'>
                                            {(item?.is_expired == 0 && item?.cancelled_at == null) ? <span>
                                                <button
                                                    className='mt-3 btn btn-primary btn-sm'
                                                    type='button'
                                                    disabled={downloadQR}
                                                    onClick={() => downloadPermitQr(item?.id, item?.account_number)}>
                                                    Download QR
                                                </button>
                                            </span> : <span></span>}
                                            {/* {item?.user_consent === '1' && <>
                                            <button className='mt-3 btn btn-danger btn-sm' onClick={() => cancelPermit(item)}>Cancel Auto Renew 2</button>
                                        </>} */}
                                            {/* <div className="w-auto">
       
                                        <div className="form-check form-switch">
  <input className="form-check-input" type="checkbox" role="switch" id='autopayconsent' name='autopayconsent' checked={isConsent} onChange={() => cancelPermit(item)} />
  <label className="form-check-label" htmlFor="autopayconsent">AutoPay Consent</label>
</div>
                                <i className='d-block small'>By clicking this button, you are providing<br/> your consent for auto renewal.</i>

                            </div> */}

                                        </div> : null}
                                        {/* <div>
                                        <small className='text-danger'>{userData?.user?.license_number != item?.license_number ? errorMessages?.licenseAlertMessage : ''}</small>
                                    </div> */}
                                    </div>



                                    {item?.permit_ticket && item?.permit_ticket.length > 0 ? <span className=' fw-bold text-primary text-decoration-underline ms-3' onClick={() => handleshowCheckIn()} >{displayCheckIn ? 'Hide Check-In List' : 'Show Check-In List'}</span> : ''}
                                    <div className="card-body table-responsive">
                                        {(displayCheckIn && item?.permit_ticket.length > 0) ?
                                            <table className="table table-borderless">
                                                <thead>
                                                    <tr className='text-muted'>
                                                        <th scope="col" className='tableLicensePlate'>Ticket #</th>
                                                        <th scope="col">License Plate</th>
                                                        <th scope="col">Check-In At</th>
                                                        <th scope="col">Check-Out At</th>
                                                        <th scope='col'>Amount Paid</th>
                                                        {/* <th scope='col'>Card Details</th> */}
                                                        <th scope='col'>Reference ID</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr key={index}>
                                                        <td>{item?.permit_ticket[0]?.ticket_number}</td>
                                                        <td>{item?.permit_ticket[0]?.license_plate}</td>
                                                        <td>{item?.permit_ticket[0]?.checkin_time ? moment(item?.permit_ticket[0]?.checkin_time).format('MM/DD/YYYY') + ', ' + moment(item?.permit_ticket[0]?.checkin_time).format('h:mm A') : '-'}</td>
                                                        <td>{item?.permit_ticket[0]?.checkout_datetime ? moment(item?.permit_ticket[0]?.checkout_datetime).format('MM/DD/YYYY') + ', ' + moment(item?.permit_ticket[0]?.checkout_datetime).format('h:mm A') : '-'}</td>
                                                        <td>{item?.permit_ticket[0]?.total}</td>
                                                        {/* <td>{(item?.permit_ticket[0]?.card_type)+ ', '+(item?.permit_ticket[0]?.payment_last_four)}</td> */}
                                                        <td>{item?.permit_ticket[0]?.permit_request_id}</td>

                                                        {/* <td>{'Active'}</td> */}
                                                    </tr>
                                                </tbody>
                                            </table> : ''}
                                    </div>
                                    {/* key card section start */}
                                    {item?.keycard_mappings && (item?.keycard_mappings.length > 0) && (
                                        <div className="card-body table-responsive p-0">
                                            <div className='border border-dashed my-3 d-block w-100'></div>
                                            <div className="d-flex align-items-center justify-content-between mb-2 flex-wrap">
                                                <span className='fw-bold text-primary mb-2'>
                                                    {'Keycard Details'}
                                                </span>
                                                {(() => {
                                                    // Check if at least one keycard mapping has status_text 'Active'
                                                    const atLeastOneActive = item?.keycard_mappings?.some(el => el?.status_text === 'Active')
                                                    // Check if any keycard mapping has status_text 'Pending'
                                                    const hasPendingReplacement = item?.keycard_mappings?.some(el => el?.status_text === 'Pending')
                                                    // Disable button if none are active, or if any are pending
                                                    const disableButton = !atLeastOneActive || hasPendingReplacement

                                                    return (
                                                        <button
                                                            type="button"
                                                            className='btn btn-primary btn-sm ms-3'
                                                            style={{
                                                                cursor: !disableButton ? 'pointer' : 'not-allowed',
                                                                color: !disableButton ? undefined : 'grey',
                                                                opacity: !disableButton ? 1 : 0.7,
                                                                fontWeight: 500,
                                                                borderColor: !disableButton ? undefined : 'grey',
                                                            }}
                                                            onClick={() => {
                                                                if (!disableButton) {
                                                                    const activeKeycard = (item?.keycard_mappings || [])?.find(el => el?.status_text === 'Active')
                                                                    let payload = {
                                                                        'keycard_id': activeKeycard?.keycard_id,
                                                                        'facility_id': item?.facility_id
                                                                    }
                                                                    keyCardData['facility_id'] = item?.facility_id
                                                                    setKeyCardData({ ...keyCardData })
                                                                    dispatch(keycardReplacementDetails(payload)).then((res) => {
                                                                        keyCardModalRef.current = {
                                                                            ...keyCardModalRef.current,
                                                                            replacementDetails: res
                                                                        }
                                                                        keyCardModalRef.current = {
                                                                            ...keyCardModalRef.current,
                                                                            currentPermitItem: item
                                                                        }
                                                                        setShowKeyCardChangeModal(true)
                                                                    })
                                                                }
                                                            }}
                                                        >
                                                            Request Keycard Replacement
                                                        </button>
                                                    )
                                                })()}
                                            </div>
                                            <table className="table table-bordered table-sm mb-0">
                                                <thead>
                                                    <tr className='text-muted'>
                                                        <th scope="col" className='tableLicensePlate'>Request Date</th>
                                                        <th scope="col" className='tableLicensePlate'>Keycard Number</th>
                                                        <th scope="col">Amount</th>
                                                        <th scope="col">Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {item?.keycard_mappings?.map((el, index) => {
                                                        return <tr key={index}>
                                                            <td>{el?.request_date ? moment(el?.request_date).format('MM/DD/YYYY hh:mm a') : '-'}</td>
                                                            <td>{el?.keycard_number || '-'}</td>
                                                            <td>{el?.total_amount ? el?.total_amount : '-'}</td>
                                                            <td><span className={`${keycardStatus(el?.status_text)}`}>{el?.status_text || 'N/A'}</span></td>
                                                        </tr>
                                                    })}
                                                </tbody>
                                            </table>

                                            {/* Modal for Keycard Change Request */}
                                            <ConfirmationModal
                                                title='Keycard Replacement Request'
                                                showModal={showKeyCardChangeModal}
                                                setShowModal={setShowKeyCardChangeModal}
                                                dispatch={dispatch}
                                                notify={notify}
                                                description={keyCardDescription()}
                                                resetData={handleResetData}
                                                handleDispatchAction={() => {
                                                    // Always use ref for latest/correct permit data
                                                    if (keyCardModalRef?.current?.currentPermitItem) {
                                                        return handleKeyCardChangeRequest(keyCardModalRef?.current?.currentPermitItem)
                                                    }
                                                }}
                                            />
                                        </div>
                                    )}

                                    {/* key card section end */}



                                    {/*  permiit uses section */}
                                    {(permitUsagelist?.length > 0) && !isPermissionExist(accessPermissions, 'Get Permit By Email') ? <> <div className='border border-dashed my-4 d-block w-100'></div>
                                        <h4 className=" h6 fw-bold text-secondary">Remaining Usages</h4>

                                        <div className=" d-flex align-items-center justify-content-between">

                                            <ul className="availableSections" style={{ flexWrap: 'wrap' }}>
                                                {permitUsagelist}
                                            </ul>
                                            <p className="m-0"><b>{permitUsageRemaning ? permitUsageRemaning : '0'}</b> out of <b className="text-success">{totalUsage ? totalUsage : '0'}</b> available</p>

                                        </div></> : null}

                                    {/* {isPermissionExist(accessPermissions, 'Display Terms & Conditions') ? <span onClick={handleModalTerm} className='col-12 text-end m-0 pe-3 pb-3 text-decoration-underline cursor'>Terms & Conditions</span> : null} */}
                                    <ModalTerm partnerDetails={partnerDetails} facilityId={item?.facility?.id} setShow={setTermShow} show={showTerm} />


                                </li>
                            )
                        })}
                    </ul> : renderNoResults(displayError)}
                <AddCardPaymentModal 
                    isModalOpen={isModalOpen} 
                    hanndleCancel={hanndleCancel} 
                    cardList={cardList} 
                    setPayload={setPayload} 
                    setCardList={setCardList} 
                    setCardFormVisible={setCardFormVisible} 
                    isCardFormVisible={isCardFormVisible} 
                    setModal={setModal} 
                    handleSubmit={handleSubmit} 
                    payload={payload} 
                    modalName='Add Payment' 
                    isLoading={isLoading} 
                    handleCardChange={handleCardChange} 
                    handleExpiryChange={handleExpiryChange} 
                    handleCardSelectChange={handleCardSelectChange} 
                    expiry={expiry} 
                    cardExpiryMessage={cardExpiryMessage} 
                    card={card} 
                    errorMessage={errorMessagePay} 
                    error={error} 
                    setErrorMessage={setErrorMessagePay} 
                    setError={setError} 
                    setCard={setCard} 
                    setExpiry={setExpiry} 
                    handleInputFieldsData={handleInputFieldsData} 
                    partnerDetails={partnerDetails} 
                    isFiservGateway={isFiservGateway}
                    facilityDetails={facilityDetails}
                    tokenRef={tokenRef}
                    iframeErrorMsg={iframeErrorMsg}
                    setIframeErrorMsg={setIframeErrorMsg}
                    cardToken={cardToken}
                    setCardToken={setCardToken}
                />
                <ConfermationModal
                    setConfermationModal={setCancelModal}
                    confermationModal={cancelModal}
                    isLoading={isCancelLoading}
                    confermationHeading="Cancel Permit"
                    confermationMessage="Are you sure you want to cancel this permit?"
                    warning={buyoutType ? 'A cancellation charge of $75 is deducted from your card, and your credit card will not be charged 1st of next month.' : ''}
                    buttonLable="Cancel Permit"
                    handleDelete={cancelPermit}
                />
            </div>
    )
}

PermitAccount.propTypes = {
    dispatch: PropTypes.func,
    loader: PropTypes.bool,
    partnerDetails: PropTypes.object,
    notify: PropTypes.func,

}

PermitAccount.defaulProps = {
    dispatch: noop,
    loader: false,
    partnerDetails: EMPTY_OBJECT,
    notify: noop,

}

function mapStateToProps({ permitListReducer, PartnerReducer }) {
    return {
        loader: permitListReducer?.loader,
        partnerDetails: PartnerReducer?.partnerDetails?.data,
    }
}
export default connect(mapStateToProps)(PermitAccount)